import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getProducts } from "../../api/apiProducts";
import { PAGE_SIZE } from "../../utils/constants";
import i18next from "i18next";
import { useParams } from "react-router-dom";

export function useProducts(productCategorySlug, page) {
    const queryClient = useQueryClient();
    const { slug } = useParams();
    const {
        isLoading,
        data: products,
        error,
        isFetching
    } = useQuery({
        queryKey: ["products", slug || productCategorySlug, page, i18next.language],
        queryFn: () => getProducts(slug || productCategorySlug, page),
        retry: false,
    });

    // **تحسين الـ Prefetching**
    const pageCount = products ? Math.ceil(products.length / PAGE_SIZE) : 0;

    if (page < pageCount) {
        queryClient.prefetchQuery({
            queryKey: ["products", slug || productCategorySlug, page + 1, i18next.language],
            queryFn: () => getProducts(slug || productCategorySlug, page + 1),
        });
    }

    if (page > 1) {
        queryClient.prefetchQuery({
            queryKey: ["products", slug || productCategorySlug, page - 1, i18next.language],
            queryFn: () => getProducts(slug || productCategorySlug, page - 1),
        });
    }

    return { isLoading, error, products, isFetching };
}
